import React, { cloneElement, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { setAnsweringQuestionsAction, checkAnswerForInspectionAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { setAnswerEditorAction } from "../../../../redux/answeringQuestions/answerEditor";
import useLocalStorage from "../../../../hooks/useLocalStorage";

const Submitter = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const answerEditor = useSelector( state => state.answerEditor );

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };
  const checkAnswerForInspection = () => { dispatch( checkAnswerForInspectionAction() ) };
  const setAnswerEditor = payload => { dispatch( setAnswerEditorAction( payload ) ) };

  const { setUserData } = useLocalStorage();

  const changeKeypad = () => {
    const isNotepad = TYPE.KEYPAD.NOTE === answeringQuestions.keypadType;
    const keypadType = isNotepad ? answeringQuestions.data.kypdTyCd : TYPE.KEYPAD.NOTE;
    setAnsweringQuestions( { keypadType } );
    setUserData( { isKeypad : isNotepad } );
  };

  const answering = () => {
    if ( answeringQuestions.answer.length === answeringQuestions.answer.filter( v => v?.indexOf( '\\phantom' ) === -1 ).length ) {
      checkAnswerForInspection();
    } else {
      setAnsweringQuestions( { isShowNotEnteredAnswerPopup : true } );
    }
  };

  const prevCursor = () => {
    const changedAnswerIndex = answeringQuestions.answerIndex - 1;
    setAnsweringQuestions( { answerIndex : 0 > changedAnswerIndex ? answeringQuestions.answer.length - 1 : changedAnswerIndex } );
    ! answerEditor.isShow && setAnswerEditor( { answerKey : '' } );
  };

  const nextCursor = () => {
    const changedAnswerIndex = answeringQuestions.answerIndex + 1;
    setAnsweringQuestions( { answerIndex : answeringQuestions.answer.length <= changedAnswerIndex ? 0 : changedAnswerIndex } );
    ! answerEditor.isShow && setAnswerEditor( { answerKey : '' } );
  };

  return cloneElement( props.children || <Fragment />, {
    onChangeKeypad : changeKeypad,
    onAnswering : answering,
    onPrevCursor : prevCursor,
    onNextCursor : nextCursor
  } );

};

export default Submitter;
